'use strict';

export default class ImportController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, $scope, Upload, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$scope = $scope;
    this.Upload = Upload;
    this.toaster = toaster;
  }

  upload(file) {
    this.toaster.pop({
      type: 'wait',
      title: '正在导入，请稍等...',
      body: file.name,
      timeout: 3000 * 1000
    });

    file.upload = this.Upload.upload({
      url: `/api/betaGroups/${this.$stateParams.id}/import`,
      file: file,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    file.upload.progress((evt) => {
      file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
    });

    file.upload.success((data, status, headers, config) => {
      this.toaster.clear();
      this.toaster.pop('success', '导入成功', file.name);
      this.$state.go('betagroups.show', {id: this.$stateParams.id});
    });

    file.upload.error((err) => {
      this.toaster.clear();
      this.toaster.pop('error', '导入失败', JSON.stringify(err));
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/betagroups/import/import.controller.js